// @owners { team: patients-team }

let removeUnschedulablePrescriptionsChain = Promise.resolve();

export const enqueueRemoveUnschedulablePrescriptionsWork = (run: () => Promise<void>): void => {
  removeUnschedulablePrescriptionsChain = removeUnschedulablePrescriptionsChain
    .catch(() => undefined)
    .then(async (): Promise<void> => {
      await run();
      return undefined;
    });

  void removeUnschedulablePrescriptionsChain;
};

/**
 * Resets the module-level removal queue. Call from Jest `beforeEach` / `afterEach` when tests exercise checkout without
 * mocking `useRemoveUnschedulablePrescriptionsFromCart`, so pending async work from one test cannot run before the next.
 *
 * Import from this module (not from `useRemoveUnschedulablePrescriptionsFromCart.tsx`) in tests that should not load
 * `@alto/features` / native transitive deps.
 */
export const resetRemoveUnschedulablePrescriptionsChainForTests = (): void => {
  removeUnschedulablePrescriptionsChain = Promise.resolve();
};
